export const AP_SEARCH_BOX_LOADER = {
  desktop: `<div class="cui-container">
  <div class="cui-skeleton-rectangle -is--block">
    <div class="cui-skeleton__item" style="width: 100%; height: 48px;"></div>
  </div>
</div>`
};
